<!-- <p>visitor-categories works!</p>-->
<div class="demo-chart-wrapper">
  <div
    echarts
    [options]="option"
    class="demo-chart"
    [ngStyle]="height ? { height: height } : {}"
  ></div>
</div>
